import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { css } from "./Theme";

const Text = props => {
  const styles = css({
    fontSize: 2
  });
  return ___EmotionJSX("span", _extends({}, props, {
    css: styles
  }), props.children);
};

export default Text;